// Ключ хранения времени закрытия баннера
export const INSTALL_DISMISSED_KEY = 'hc_install_dismissed_at';

// Интервал повторного показа подсказки (14 дней)
export const INSTALL_HINT_REPEAT_MS = 14 * 24 * 60 * 60 * 1000;

export interface InstallPromptState {
  standalone: boolean;
  hasPrompt: boolean;
  ios: boolean;
  dismissedAt: number | null;
  now: number;
}

// Проверка запуска приложения в автономном режиме
export function isStandalone(
  matchMedia: (q: string) => { matches: boolean },
  navStandalone: boolean | undefined
): boolean {
  return Boolean(navStandalone) || matchMedia('(display-mode: standalone)').matches;
}

// Проверка на Safari под iOS / iPadOS
export function isIosSafari(userAgent: string, maxTouchPoints: number): boolean {
  const isAppleMobileDevice = /iPhone|iPad|iPod/i.test(userAgent);
  const isIpadOsDesktopMode = /Macintosh/i.test(userAgent) && maxTouchPoints > 1;

  if (!isAppleMobileDevice && !isIpadOsDesktopMode) {
    return false;
  }

  // Сторонние браузеры под iOS
  const isOtherIosBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);
  if (isOtherIosBrowser) {
    return false;
  }

  return /Safari/i.test(userAgent) || isIpadOsDesktopMode;
}

// Определение необходимости отображения баннера установки
export function shouldShowInstallHint(state: InstallPromptState): 'prompt' | 'ios' | null {
  if (state.standalone) {
    return null;
  }

  if (state.dismissedAt !== null && state.now - state.dismissedAt < INSTALL_HINT_REPEAT_MS) {
    return null;
  }

  if (state.hasPrompt) {
    return 'prompt';
  }

  if (state.ios) {
    return 'ios';
  }

  return null;
}
